import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DS_ButtonLink from 'mui/components/elements/DS_ButtonLink';
import { DS_palette as corePalette } from 'mui/base/theme/DS_Tokens/core';
import { LoaderSpinner } from '../../../../../../../elements';
import { Wrapper, StyledWrapperLoader } from './styles';

const WaitlistLink = ({
  waitlistFlow,
  waitListLink,
  locationCode,
  waitlistButtonLabel,
  addMeToWaitlist,
  buttonVariant = 'contained',
  buttonIcon = 'No Icon',
  buttonSize,
  location,
  iconPlacement,
  icon,
}) => {
  const [isClicked, setIsClicked] = useState(false);

  const handleButtonClick = location => {
    setIsClicked(true);
    addMeToWaitlist(location);
  };

  return (
    <Wrapper>
      {waitlistFlow === 'link to waitlist page' ? (
        <DS_ButtonLink
          url={`${waitListLink.url}?location=${locationCode}`}
          title={waitListLink?.title || 'Add me to the waiting list'}
        ></DS_ButtonLink>
      ) : !isClicked ? (
        <DS_ButtonLink
          buttonSize={buttonSize}
          buttonIcon={buttonIcon}
          buttonVariant={buttonVariant}
          iconPlacement={iconPlacement}
          icon={icon}
          className="primary-link"
          type="button"
          onClick={() => handleButtonClick(location)}
          title={waitlistButtonLabel || 'Add me to the waiting list'}
        ></DS_ButtonLink>
      ) : (
        <StyledWrapperLoader>
          <LoaderSpinner color={`${corePalette.blue[500]}`} />
        </StyledWrapperLoader>
      )}
    </Wrapper>
  );
};

WaitlistLink.propTypes = {
  totalSlots: PropTypes.number,
  waitListLink: PropTypes.object,
  locationCode: PropTypes.string,
};

export default WaitlistLink;
